export const OPPORTUNITIES_QUERY_STRING = {
  SPECIFIC_PROJECT: 'specific_project',
  SPECIFIC_ROLE: 'specific_role',
  PROJECT_ROLES: 'project_roles',
  OPPORTUNITY_LIST: 'oppotunity_list',
  OPPORTUNITIES_TAB_AGGREGATES: 'opportunities_tab_aggregates',
  OPPORTUNITIES_PUBLIC_AGGREGATES: 'opportunities_public_aggregates',
  OPPORTUNITIES_PROFILES: 'opportunities_profiles',
  OPPORTUNITIES_AUDITION_CHECKER: 'opportunities_audition_checker',
};

export const PROFILE_LINKS_QUERY_STRING = {
  PROFILE_LIST: 'profile_list',
};
